// Interfaces
import { ICommissionCycle, IPayPeriod } from "@/Common/api/types/CommissionCycle";
import { TSubscriptionCallbackParams } from "@/Common/api/types/SubscriptionCallbackParams";
import { IUpdatedPayPeriodsProviders } from "./interfaces";

const getPayPeriodProviders = (payPeriod: IPayPeriod) => payPeriod?.payPeriodProviders ?? [];

const isPeriodInCycle = (cycle: ICommissionCycle, payPeriodsIds: string[]) => {
	return cycle?.payPeriods?.some((period) => payPeriodsIds.includes(period._id));
};

const updateCyclePayPeriodProviders = (cycle: ICommissionCycle, payPeriod: IPayPeriod) => {
	cycle["payPeriods"] = cycle.payPeriods.map((period) => {
		if (period._id === payPeriod._id) {
			period["payPeriodProviders"] = getPayPeriodProviders(payPeriod);
		}
		return period;
	});
	return cycle;
};

const getUpdatedPayPeriodsInCycle = (cycle: ICommissionCycle, payPeriods: IPayPeriod[]) => {
	const updatedCycle = { ...cycle };
	for (const period of payPeriods) {
		if (isPeriodInCycle(cycle, [period._id])) {
			updateCyclePayPeriodProviders(updatedCycle, period);
		}
	}
	return updatedCycle;
};

const updateCycles = (cycles: ICommissionCycle[], payPeriods: IPayPeriod[]) => {
	const periodsIds = payPeriods.map((period) => period._id);
	return cycles.map((cycle) => {
		if (isPeriodInCycle(cycle, periodsIds)) {
			const updatedCycle = getUpdatedPayPeriodsInCycle(cycle, payPeriods);
			return {
				...updatedCycle,
			};
		}
		return cycle;
	});
};

const onUpdatePayPeriodsProvidersCallback = ({
	queryClient,
	response,
}: TSubscriptionCallbackParams<"onUpdatePeriodPayrollProviders", IUpdatedPayPeriodsProviders>) => {
	if (!response.data?.onUpdatePeriodPayrollProviders) {
		return;
	}
	const { locationId, payPeriods = [] } = response.data?.onUpdatePeriodPayrollProviders ?? {};
	if (payPeriods?.length) {
		queryClient.setQueryData(["commissionCycles", locationId], (oldData: ICommissionCycle[]) => {
			return updateCycles([...oldData], payPeriods);
		});
	}
};

export { onUpdatePayPeriodsProvidersCallback, getPayPeriodProviders };
